module.exports = __webpack_public_path__ + "static/logo_homes_mobile-cb69b6aac777eb6dbdbe0e5a04bbadba.png";